import React, {ReactNode} from 'react';

import {useStore} from 'effector-react';

import {permissions$, profile$} from 'models/auth';
import {UserPermissionValue, UserRoles} from 'types';
import {hasAccessByRoles} from 'utils/roles';

interface Props {
    permissions?: UserPermissionValue[];
    children: ReactNode;
    placeholder?: ReactNode;
    roleAccess?: UserRoles[];
}

export function PermissionAccess({children, permissions, placeholder, roleAccess}: Props) {
    const currentPermissions = useStore(permissions$);
    const user = useStore(profile$);
    if (!user) {
        return <>{placeholder ?? null}</>;
    }

    const allowedByRole = hasAccessByRoles(roleAccess);

    if (
        !permissions ||
        permissions.some((elem) => currentPermissions?.includes(elem)) ||
        allowedByRole
    ) {
        return <>{children}</>;
    }

    return <>{placeholder ?? null}</>;
}
